/**
 * Luna Lee — infinite scroll on collection pages (8 products per page).
 */
(function () {
  function initInfiniteScroll() {
    var section = document.querySelector(
      '[data-section-type="collection-template"][data-llj-infinite]'
    );
    if (!section) return;

    var grid = section.querySelector('[data-llj-product-grid]');
    var sentinel = section.querySelector('[data-llj-infinite-sentinel]');
    if (!grid || !sentinel) return;

    var nextUrl = section.getAttribute('data-next-url') || '';
    var loading = false;
    var observer;

    function setLoading(on) {
      loading = on;
      if (on) sentinel.classList.add('is-loading');
      else sentinel.classList.remove('is-loading');
      var label = sentinel.querySelector('.llj-infinite-sentinel__label');
      if (label) label.style.visibility = on ? 'visible' : 'hidden';
    }

    function finish() {
      nextUrl = '';
      section.removeAttribute('data-next-url');
      sentinel.setAttribute('hidden', 'hidden');
      if (observer) observer.disconnect();
    }

    function appendProducts(doc) {
      var nextGrid = doc.querySelector('[data-llj-product-grid]');
      if (!nextGrid) return;
      var items = nextGrid.children;
      for (var i = 0; i < items.length; i++) {
        var node = items[i];
        if (node.nodeType !== 1) continue;
        if (!node.classList.contains('grid__item')) continue;
        grid.appendChild(document.importNode(node, true));
      }
      if (window.lazySizes && lazySizes.loader) {
        lazySizes.loader.checkElems();
      }
    }

    function loadMore() {
      if (loading || !nextUrl) return;
      setLoading(true);
      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('bad status');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          appendProducts(doc);
          var nextSection = doc.querySelector(
            '[data-section-type="collection-template"][data-llj-infinite]'
          );
          var newNext = nextSection
            ? nextSection.getAttribute('data-next-url') || ''
            : '';
          if (newNext) {
            nextUrl = newNext;
            section.setAttribute('data-next-url', newNext);
          } else {
            finish();
          }
        })
        .catch(function () {
          // keep sentinel so user can scroll again to retry
        })
        .then(function () {
          setLoading(false);
        });
    }

    // Hide label until actively loading
    setLoading(false);
    var label = sentinel.querySelector('.llj-infinite-sentinel__label');
    if (label) label.style.visibility = 'hidden';

    if (!nextUrl) {
      finish();
      return;
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              loadMore();
              break;
            }
          }
        },
        { rootMargin: '600px 0px', threshold: 0 }
      );
      observer.observe(sentinel);
    } else {
      // Fallback: simple scroll listener
      window.addEventListener('scroll', function onScroll() {
        if (!nextUrl) {
          window.removeEventListener('scroll', onScroll);
          return;
        }
        var rect = sentinel.getBoundingClientRect();
        if (rect.top < window.innerHeight + 600) loadMore();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  } else {
    initInfiniteScroll();
  }
})();
